<template>
  <div>
    <div>
      <el-form :inline="true" ref="form2" @submit.native.prevent>
        <el-form-item label="标题">
          <el-input v-model="param.title" maxlength="200" style="width: 200px" @keyup.native.enter="list"></el-input>
        </el-form-item>
        <el-form-item label="作者">
          <el-input v-model="param.author" maxlength="200" style="width: 200px" @keyup.native.enter="list"></el-input>
        </el-form-item>
        <el-form-item label="内容">
          <el-input v-model="param.shi" maxlength="200" style="width: 200px" @keyup.native.enter="list"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="list">查询</el-button>
          <el-button type="primary" @click="random">随机</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div align="center">
      <el-table :data="tableData" ref="dataTable" style="width: 100%">
        <el-table-column type="index" label="序号" width="50"/>
<!--        <el-table-column prop="type" label="类别" width="100" show-overflow-tooltip/>-->
        <el-table-column prop="title" label="标题" width="200" show-overflow-tooltip/>
        <el-table-column prop="author" label="作者" width="120" show-overflow-tooltip/>
        <el-table-column prop="shi" label="内容" show-overflow-tooltip/>
      </el-table>
    </div>
  </div>
</template>

<script>
import * as http from '../api/http'
import global from '../components/Global'

export default {
  name: 'Tangshi',
  data () {
    return {
      tableData: [],
      param: {title: null, shi: null, author: null}
    }
  },
  created () {
    // this.list()
  },
  methods: {
    list () {
      if (this.param.title === null && this.param.shi === null && this.param.author === null) {
        this.$message.error('请输入查询条件。')
        return
      }
      this.tableData = []
      http.post(global.url0 + 'shi360/like/', this.param).then(
        res => {
          let resStr = res.toString
          if (resStr.length > 0 && !String.startsWith(resStr, '[')) {
            this.$message.error(res)
            return
          }
          // console.log(res)
          this.tableData = res
        }
      )
    },
    random () {
      this.tableData = []
      http.post(global.url0 + 'shi360/random/', null).then(
        res => {
          let resStr = res.toString
          if (resStr.length > 0 && !String.startsWith(resStr, '[')) {
            this.$message.error(res)
            return
          }
          // console.log(res)
          this.tableData = res
        }
      )
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/views/Tangshi.vue